import { ItemQuestionario } from "src/app/questionario/questao/item-questionario-base";
import { TipoItemQuestionario } from "src/app/questionario/questao/model/tipo-item-questionario.enum";

export class QuestaoObjetiva extends ItemQuestionario<TipoItemQuestionario> {
  options: {
    key: string,
    value: string
  }[] = [];

  constructor(options: {} = {}) {
    super(options);
    this.options = options['options'] || [];
    this.questao.tipo = TipoItemQuestionario.OBJETIVA;
  }

  getLabel(): string {
    return 'Objetiva';
  }

  getMaterialIcon(): string {
    return 'radio_button_checked';
  }

  isQuestaoEstruturada(): boolean {
    return true;
  }
}
